<template>
  <div class="a-accordion">
    <form>
      <div class="a-filter__body u-padding-top-24px">
        <div class="a-container-form ">
          <div class="a-label a-label--w-215">Номер задания</div>
          <input type="text"
                 class="a-input a-input--w-380"
                 v-model="filters.taskNumber"/>
        </div>

        <div class="a-container-form ">
          <div class="a-label a-label--w-215">Доступность</div>
          <dropdown-new class="select-w-570" v-model="filters.availability">
            <option value>Все</option>
            <option :value="true">Использован</option>
            <option :value="false">Доступен</option>
          </dropdown-new>
        </div>

        <div class="a-container-form ">
          <div class="a-label a-label--w-215">Организатор</div>
          <user-search class="select-w-570"
                       organizer
                       tags
                       v-model="filters.owner"
                       :placeholder="$t('form.user-search.registration-date.user.placeholder')">
          </user-search>
        </div>
      </div>

      <div class="a-filter__footer ">
        <button class="gui-btn gui-btn--white-border gui-btn--w-167" type="button" @click="resetFilters" v-t="'buttons.reset-filters'"></button>
        <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" @click="onApplyClick" v-t="'buttons.apply'"></button>
      </div>
    </form>

    <div class="a-accordion__btn-tab">
      <div class="a-accordion__label a-accordion__label--open">
        <img src="@/assets/img/static/arrow-vector.png" alt="">
        {{$t('labels.catalog-upper-level')}}
      </div>

      <button class="a-accordion__add-btn-label" type="button" @click="createNewItem">
        <img src="@/assets/img/static/b-icon_plus-str.svg" alt="">
        {{$t('form.catalogs.catalog-type.lot-numbers.add-number')}}
      </button>
    </div>

    <div class="a-container-form align-content-center" v-if="newItem.active">
      <div class="table-tab__container align-content-center" tabindex="1" style="overflow: hidden; outline: none;">
        <table class="table-tab__block table " style="width: 1200px">
          <thead class="table-tab__thead">
          <tr class="table-tab__height-auto-column-header" style="height: 48px;">
            <th>Номер задания</th>
            <th>Количество лотов</th>
            <th>Дата</th>
          </tr>
          </thead>
          <tbody class="table-tab__tbody">
            <tr class="">
              <td>
                <input type="text"
                       class="a-input a-input--w-380"
                       v-model="newItem.taskNumber">
              </td>
              <td>
                <input-number class="a-input a-input--w-80 "
                              v-model="newItem.quantity">
                </input-number>
              </td>
              <td>
                <div class="a-input-group ">
                  <div class="a-input-group__prepend ">
                    <img src="@/assets/img/static/vector.svg" alt="">
                  </div>
                  <date-picker v-model="newItem.date"></date-picker>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="a-filter__footer ">
          <button class="gui-btn gui-btn--white-border gui-btn--w-167" type="button" @click="onCreateClick">Создать</button>
          <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" @click="onCancelClick">Отменить</button>
        </div>
      </div>
    </div>

    <lot-numbers-catalog-list
      v-if="items"
      :items="items"
      @addItem="createNewItem($event)"
      @editItem="editItem($event)"
      @deleteItem="deleteItem($event)"
      @confirmEditable="confirmEditable($event)"
      @cancelEditable="cancelEditable($event)"
    >
    </lot-numbers-catalog-list>

    <div class="table-tab__nav">
      <nav>
        <ul class="pagination">
          <li class="page-item prev">
              <span class="page-link" @click="onPrevPageClick">
                <img src="@/assets/img/static/arrow-next-prev.png" alt="">
              </span>
          </li>

          <li class="page-item" :class="{'active': p.active, 'disabled': p.disabled}" v-for="p in pages">
            <span class="page-link" @click="onPageClick(p)">{{p.label}}</span>
          </li>

          <li class="page-item next">
              <span class="page-link" @click="onNextPageClick">
                <img src="@/assets/img/static/arrow-next-prev.png" alt="">
              </span>
          </li>
        </ul>
      </nav>

      <div class="admin-buy__show-item">
        <p>{{$t('labels.show-by')}}</p>
        <dropdown-new class="select-w-77" v-model.number="pageSize">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="50">50</option>
        </dropdown-new>
      </div>
    </div>

    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import LotNumbersCatalogList from "./LotNumbersCatalogList";
  import Loading from '@/components/Loading'
  import _ from 'lodash'
  import UserSearch from '@/components/common/inputs/UserSearch'

  let uniqueId = Date.now();

  export default {
    components: {
      LotNumbersCatalogList,
      Loading,
      UserSearch
    },

    data: function() {
      return {
        filters: {
          owner: undefined,
          taskNumber: undefined,
          availability: undefined
        },
        newItem: {
          active: false,
          taskNumber: undefined,
          quantity: 1,
          date: new Date()
        },
        pageSize: 10,
        page: 1
      }
    },

    computed: {
      totalPages() {
        return Math.ceil(this.$store.getters.lotNumbers.total / this.pageSize) || 0;
      },

      pages() {
        const minPage = Math.max(1, this.page - 4);
        const maxPage = Math.min(minPage + 10, this.totalPages);
        const pages = [];

        for (let id = minPage; id <= maxPage; ++id) {
          if (id === minPage && minPage !== 1) {
            pages.push({
              disabled: true,
              label: '...'
            });
          }
          else if (id === maxPage && maxPage !== this.totalPages) {
            pages.push({
              disabled: true,
              label: '...'
            });
          }
          else {
            pages.push({
              active: id === this.page,
              id: id,
              label: id
            })
          }
        }

        return pages;
      },

      items() {
        return this.$store.getters.lotNumbers.items;
      }
    },

    watch: {
      pageSize() {
        this.page = 1;
        this.fetchLotNumbers();
      }
    },

    async created() {
      return this.fetchLotNumbers();
    },

    methods: {
      onApplyClick() {
        this.page = 1;
        return this.fetchLotNumbers();
      },

      async onCreateClick() {
        const baseItem = {
          taskNumber: this.newItem.taskNumber,
          lotNumber: this.newItem.taskNumber,
          date: this.newItem.date
        };

        let items = [];
        if (this.newItem.quantity === 1) {
          items.push(baseItem)
        }
        else {
          for (let id = 0; id < this.newItem.quantity; ++id) {
            items.push({
              ...baseItem,
              lotNumber: `${baseItem.lotNumber} (Лот ${id + 1})`
            })
          }
        }

        return this.runBlockerAction(async () => {
          for (let id = 0; id < this.newItem.quantity; ++id) {
            try {
              await this.$store.dispatch('addLotNumberToCatalog', {
                num: items[id].lotNumber,
                numTask: items[id].taskNumber,
                time: +items[id].date || undefined
              });
            }
            catch(e) {
              console.error('unable to add lot number to catalog', e);
              this.globalErrorHandler(e);
            }
          }
          this.onCancelClick();
        });
      },

      async onCancelClick() {
        Object.assign(this.$data.newItem, this.$options.data.apply(this).newItem);
      },

      async fetchLotNumbers() {
        return this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchLotNumbersFromCatalog', {
              taskNumber: this.filters.taskNumber || undefined,
              availability: this.filters.availability,
              owner: _.get(this.filters.owner, 'id'),
              page: this.page,
              pageSize: this.pageSize
            });
          }
          catch(e) {
            console.error('unable to fetch list fo lot numbers', e);
            this.globalErrorHandler(e);
          }
        });
      },

      resetFilters() {
        Object.assign(this.$data.filters, this.$options.data.apply(this).filters);
      },

      createNewItem(data) {
        this.newItem.active = true;
      },

      deleteItem(data) {
        const idx = _.findIndex(this.items, { id: data.id });
        if (idx === -1) return;

        this.runAction(async() => {
          try {
            await this.$store.dispatch('deleteLotNumberFromCatalog', data);
          }
          catch(e) {
            console.error('unable to delete lot number from catalog', e);
            this.globalErrorHandler(e);
          }
        });
      },

      editItem(data) {
        const idx = _.findIndex(this.items, { id: data.id });
        if (idx === -1) return;

        const item = this.items[idx];
        item.editable = true;
        item.backup = item.name;

        this.$set(this.items, idx, item);
      },

      findElement(data) {
        let fieldId = 'id';

        if (data[fieldId] === undefined) {
          fieldId = 'localId';
        }

        const filter = {};
        filter[fieldId] = data[fieldId];

        const idx = _.findIndex(this.items, filter);
        return idx;
      },

      async confirmEditable(data) {
        const idx = this.findElement(data);
        if (idx === -1) return;

        const item = this.items[idx];

        if (item.isNew) {
          item.id = Date.now();
        }

        this.runAction(async () => {
          try {
            if (item.isNew) {
              //await this.$store.dispatch('addLotNumberToCatalog', data);
            }
            else {
              await this.$store.dispatch('modifyLotNumberInCatalog', {
                ...data,
                ...{
                  taskNumber: this.filters.taskNumber || undefined,
                  availability: this.filters.availability,
                  owner: _.get(this.filters.owner, 'id'),
                  page: this.page,
                  pageSize: this.pageSize
                }
              });
            }
          }
          catch(e) {
            console.error('unable to modify/add lot number in/to catalog', e);
            this.globalErrorHandler(e);
          }
        });
      },

      cancelEditable(data) {
        const idx = this.findElement(data);
        if (idx === -1) return;

        const item = this.items[idx];

        if (item.isNew) {
          this.items.splice(idx, 1);
        }
        else {
          item.name = item.backup;
          item.editable = false;
          this.$set(this.items, idx, item);
        }
      },

      onPrevPageClick() {
        if (this.page > 1) {
          --this.page;
          this.fetchLotNumbers();
        }
      },

      onNextPageClick() {
        if (this.page < this.totalPages) {
          ++this.page;
          this.fetchLotNumbers();
        }
      },

      onPageClick(page) {
        if (!page.disabled && !page.active) {
          this.page = page.id;
          this.fetchLotNumbers();
        }
      },
    }
  }
</script>

<style scoped>

</style>
